(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target instanceof Element ? event.target.closest('.ml-footer-menu-toggle') : null;
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
  });
  } catch(e) { console.error(e); }
})();

})();
